import firebase from "firebase";
import {getPlans} from "./plan";

export const getVersions = async (id) => {
  const response = await myFirestore
    .collection('projects')
    .doc(id)
    .collection('versions')
    .orderBy("index", 'asc').get();

  const result = []

  response.forEach((subDoc) => {
    const data = subDoc.data();
    result.push({
      ...data,
      id: subDoc.id || null,
    });
  });

  return result
}


export const checkVersion = async (version, projectID) => {
  if (!version) return false


  const plans = await getVersions(projectID);
  const find = plans.find((p) => p.id === version.id);

  if (!find) {
    localStorage.removeItem('version')

    return false
  }

  return true
}



// WEBPACK FOOTER //
// ./src/firestore/versions.js